import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'loop-setting-column',
  template: `
    <div class="flex justify-between padding-vertical items-center">
      <div class="flex flex-col justify-center">
        <div class="setting-title">{{ nameSignal() }}</div>
        @if (descriptionSignal(); as description) {
          <div class="setting-subtitle">{{ description }}</div>
        }
      </div>

      <ng-content />
    </div>
  `,
  styles: `
    :host {
      display: block;

      .setting-title {
        display: block;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 3px;
        color: var(--strong-ui-element);
      }

      .setting-subtitle {
        display: block;
        font-size: 12px;
        color: var(--medium-ui-element);
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingColumnComponent {
  readonly nameSignal: InputSignal<string> = input.required({ alias: 'name' });
  readonly descriptionSignal: InputSignal<string | null> = input(null, { alias: 'description' });
}
